import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, TextInput } from '../../../types'
import { CmsConverterService, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowDotPlotsBoxConverter extends CmsConverterService<PanelRowDotPlotsBoxData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const altText = formData.st_panel_row_dot_plots_box_image_alternative_text?.value
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      headline: formData.st_panel_row_image_headline_text ?? defaultTextInput,
      headlineOverlay: formData.st_panel_row_image_headline_text_overlay ?? defaultTextInput,
      image: CmsConverterService.mapImage(formData.st_panel_row_dot_plots_box_image, lazyLoad, altText),
      index: 0
    }
  }
}

export const PANEL_ROW_DOT_PLOTS_BOX_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowDotPlotsBoxData>>('PanelRowDotPlotsBoxConverter')

export interface PanelRowDotPlotsBoxData extends ConvertedComponentData {
  image: Image;
  headline: TextInput;
  headlineOverlay: TextInput;
  index: number;
}
